import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_299: DocMigration = {
  maxSchemaVersion: "0.0.299",
  description: "wall assemblies from static room layout to room.",
  apply(json: any): any {
    const roomEdgeBehaviors: { [id: string]: any } = {};
    let count = Object.keys(json.roomEdgeBehaviors).length;
    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      const wallAssemblies = staticRoomLayout?.wallAssemblies;
      if (!wallAssemblies?.length) {
        continue;
      }

      for (const wallAssembly of wallAssemblies) {
        const id = uid();
        roomEdgeBehaviors[id] = {
          ...wallAssembly,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "WALL_ASSEMBLY",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.wallAssemblies;
    }

    json.roomEdgeBehaviors = { ...json.roomEdgeBehaviors, ...roomEdgeBehaviors };
    return json;
  },
};

export default migration_0_0_299;
